import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <motion.button
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={toggleTheme}
      className="p-2 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-300 shadow-lg border border-gray-200 dark:border-gray-700 group"
      aria-label="Toggle Theme"
    >
      <Icon 
        icon={isDarkMode ? "ph:moon-bold" : "ph:sun-bold"} 
        className={`text-xl md:text-2xl ${isDarkMode ? "text-blue-400" : "text-yellow-600"} transition-colors`}
      />
    </motion.button>
  );
};

export default ThemeToggle;
